import { render } from "./chujijishi-news.vue?vue&type=template&id=3364193d&scoped=true"
import script from "./chujijishi-news.vue?vue&type=script&lang=js"
export * from "./chujijishi-news.vue?vue&type=script&lang=js"

import "./chujijishi-news.vue?vue&type=style&index=0&id=3364193d&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3364193d"]])

export default __exports__